export default __webpack_public_path__ + "static/media/list-dot.6350f932.svg";